export class Download {
  public static async fromUrl(url: string, filename?: string) {
    const file = await fetch(url);
    const blob = await file.blob();
    const blobUrl = URL.createObjectURL(blob);

    var element = document.createElement('a');
    element.href = blobUrl;
    element.download = filename ?? 'file';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);

    URL.revokeObjectURL(blobUrl);
  }
}